import * as Alert from '@/components/ui/alert'
import { ImageOff } from 'lucide-solid'
import { type ParentProps, Show } from 'solid-js'
import { Spinner } from '@/components/ui/spinner'
import { Text } from '@/components/ui/text'
import { Box, Flex, Grid } from 'styled-system/jsx'

export const CropZone = (props: ParentProps<{ showCropper: boolean; isDetecting?: boolean }>) => {
  return (
    <div>
      <Show
        when={props.showCropper}
        fallback={
          <Grid
            height="100%"
            justifyContent="center"
            alignItems="center"
          >
            <Alert.Root {...props}>
              <Alert.Indicator asChild={(iconProps) => <ImageOff {...iconProps()} />} />
              <Alert.Content>
                <Alert.Title>No Image</Alert.Title>
                <Alert.Description>Upload an image to get started</Alert.Description>
              </Alert.Content>
            </Alert.Root>
          </Grid>
        }
      >
        <Box position="relative" height="100%">
          {props.children}
          <Show when={props.isDetecting}>
            <Flex
              position="absolute"
              inset={0}
              zIndex={10}
              direction="column"
              gap={3}
              alignItems="center"
              justifyContent="center"
              bg="black.a8"
              color="white"
            >
              <Spinner size="lg" />
              <Text fontWeight="semibold">Detecting the HVF data area...</Text>
            </Flex>
          </Show>
        </Box>
      </Show>
    </div>
  )
}
